export default [
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ './home.vue'),
    meta: {
      globalCampus: 'multiple',
      menuCode: 'pcHome',
      menuName: '首页',
    },
  },
  {
    path: '/404',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ './error.vue'),
    meta: {
      menuName: '404',
    },
  },
  {
    path: '/my-info',
    name: 'myInfo',
    component: () => import(/* webpackChunkName: "myInfo" */ './myInfo.vue'),
    meta: {
      menuName: '个人信息',
    },
  },
];
